import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "television-package-card io-eq-el" }
const _hoisted_2 = {
  class: "television-package-card__title",
  "data-eq-part": "television-package-card__title"
}
const _hoisted_3 = { class: "television-package-card__title-name" }
const _hoisted_4 = { class: "television-package-card__title-slogan" }
const _hoisted_5 = {
  class: "television-package-card__benefits",
  "data-eq-part": "television-package-card__benefits"
}
const _hoisted_6 = {
  class: "television-package-card__price",
  "data-eq-part": "television-package-card__price"
}

import List from '@/components/List.vue';
import { formatNumber } from '@/helpers';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { computed } from 'vue';
import TelevisionProducts from '../../../public/TelevisionProducts.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'TelevisionPackageCard',
  props: {
    package: {}
  },
  setup(__props: any) {

const props = __props;

const allPackages = TelevisionProducts.products as TelevisionPackageInterface[];
const monthlyBasePrice = computed(() => formatNumber(props.package.price?.recurring.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0, 2));
const includesLabel = computed((): string | undefined => {
  const includedProducts = allPackages.filter((pckg) => (props.package.price?.includes || []).includes(pckg.id));
  let includedLabel = '';

  includedProducts.forEach((pckg, inx) => {
    if (inx === 0) {
      includedLabel = `${includedLabel} das ${pckg.name}`;
    } else if (inx === includedProducts.length - 1) {
      includedLabel = `${includedLabel} und das ${pckg.name}`;
    } else {
      includedLabel = `${includedLabel}, das ${pckg.name}`;
    }
  });

  if (includedLabel.length) return `inkludiert ${includedLabel}`;

  return undefined;
});

const packageProConList = computed(() => [
  ...(props.package.benefits || []),
  ...((props.package.cons || []).map((con: string | string[]) => [
    Array.isArray(con) ? con[0] : con,
    Array.isArray(con) ? con[1] : undefined,
    'fa-solid fa-xmark',
  ])),
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.package.name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.package.slogan), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(List, {
        type: "icon",
        icon: "fa-solid fa-check",
        items: packageProConList.value
      }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, _toDisplayString(monthlyBasePrice.value) + " €/Monat", 1),
      _createElementVNode("div", null, _toDisplayString(includesLabel.value), 1)
    ])
  ]))
}
}

})